/* 离线缓存类 */
import Storage from 'store'
import * as Skey from '@/config/storage.config.js'
import Axios from 'axios'

const expirePlugin = require('store/plugins/expire')
Storage.addPlugin(expirePlugin)

Axios.defaults.headers.common['Accept'] = 'application/vnd.edusoho.v2+json'
Axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
Axios.defaults.headers.delete['Content-Type'] = 'application/x-www-form-urlencoded'
Axios.defaults.headers.patch['Content-Type'] = 'application/x-www-form-urlencoded'
Axios.interceptors.request.use(config => {
  const token = Storage.get(Skey.SKEY_TOKEN)
  if (token && token.length) {
    config.headers.common['X-Auth-Token'] = token
  }
  return config
}, error => {
  return Promise.reject(error)
})

Axios.interceptors.response.use(function (response) {
  response.isSuccess = response.status >= 200 && response.status <= 299
  return response
}, function (error) {
  if (error.response.status === 401) { // 未授权,清除登录信息
    Storage.remove(Skey.SKEY_TOKEN)
    Storage.remove(Skey.SKEY_USERINFO)
  }
  return Promise.reject(error)
})

export {Storage, Axios}



// WEBPACK FOOTER //
// ./src/util/api/tools.js